/**
 * Update date: 07-06-2023
 * Screen 2081.8
 */
import Form from 'devextreme-react/form';
import React, { useEffect, useRef, useState } from 'react';
import { useSupplyUnitPriceInquiryByMarket } from '..';
import { uniqBy } from 'lodash';
import Collapse from '../../../components/Collapse';
import PopupSelectCommonCode from 'app/components/PopupCommon/PopupSelectCommonCode';
import PopupSelectStore from 'app/components/PopupCommon/PopupSelectStore';
import PopupSelectProductGroup from '../../../components/PopupCommon/PopupSelectProductGroup';
import useDictionary from 'hooks/useDictionary';

const FormSearch = () => {
  const context: any = useSupplyUnitPriceInquiryByMarket();
  const { params, setParams, makeDataStores } = context;
  const formRef: any = useRef(null);
  const collapseRef: any = useRef(null);
  const [showModalStore, setShowModalStore] = useState(false);
  const [showModalCommonCode, setShowModalCommonCode] = useState(false);
  const [showModalProductGroup, setShowModalProductGroup] = useState(false);
  const [typeModalCommonCode, setTypeModalCommonCode] = useState<string>('');
  const [formData, setFormData] = useState<any>({
    ...params,
    storeName: '',
    storeData: [],
    productTypeName: '',
    productTypeData: [],
    supplyUnitPriceGroupName: '',
    supplyUnitPriceGroupData: [],
    largeCategoryName: '',
    largeCategoryData: [],
    mediumCategoryName: '',
    mediumCategoryData: [],
    smallCategoryName: '',
    smallCategoryData: [],
    subCategoryName: '',
    subCategoryData: [],
    productGroupName: '',
    productGroupData: [],
  });
  const { t } = useDictionary({
    programId: '2081.8',
  });
  /**
   * on change custom field
   *
   * @param {*} data
   */
  const onChangeCustomizeField = (data: any) => {
    setFormData({ ...formData, ...data });
    setParams({ ...formData, ...data });
  };

  /**
   * on change store
   *
   * @param {*} data
   */
  const onChangeStore = data => {
    const ids = [...data]?.map(o => o?.storeNo);
    onChangeCustomizeField({
      storeIds: ids,
      storeData: data,
    });
  };

  /**
   * on remove store
   *
   * @param {*} storeNo
   */
  const onRemoveStore = storeNo => {
    const l = [...formData?.storeData]?.filter(
      (o: any) => o?.storeNo !== storeNo,
    );
    const ids = [...l]?.map(o => o?.storeNo);
    onChangeCustomizeField({
      storeIds: ids,
      storeData: l,
    });
  };

  /**
   * on change common code
   *
   * @param {*} data
   * @param {*} typeModalCommonCode
   */
  const onChangeCommonCode = (data, typeModalCommonCode) => {
    const codes = [...data]?.map(o => o?.code);
    switch (typeModalCommonCode) {
      case 'largeCategory':
        onChangeCustomizeField({
          largeCategoryCodes: codes,
          largeCategoryData: data,
        });
        break;
      case 'smallCategory':
        onChangeCustomizeField({
          smallCategoryCodes: codes,
          smallCategoryData: data,
        });
        break;
      case 'mediumCategory':
        onChangeCustomizeField({
          mediumCategoryCodes: codes,
          mediumCategoryData: data,
        });
        break;
      case 'subCategory':
        onChangeCustomizeField({
          subCategoryCodes: codes,
          subCategoryData: data,
        });
        break;
      case 'productType':
        onChangeCustomizeField({
          productTypes: codes,
          productTypeData: data,
        });
        break;
      case 'supplyUnitPriceGroup':
        onChangeCustomizeField({
          supplyUnitPriceGroupIds: codes,
          supplyUnitPriceGroupData: data,
        });
        break;
      default:
        break;
    }
  };

  /**
   * on remove common code
   *
   * @param {*} code
   * @param {*} typeModalCommonCode
   */
  const onRemoveCommonCode = (code, typeModalCommonCode) => {
    switch (typeModalCommonCode) {
      case 'largeCategory':
        const largeData = [...formData?.largeCategoryData]?.filter(
          (o: any) => o?.code !== code,
        );
        const largeCodes = [...largeData]?.map(o => o?.code);

        onChangeCustomizeField({
          largeCategoryCodes: largeCodes,
          largeCategoryData: largeData,
        });
        break;

      case 'smallCategory':
        const smallData = [...formData?.smallCategoryData]?.filter(
          (o: any) => o?.code !== code,
        );
        const smallCodes = [...smallData]?.map(o => o?.code);

        onChangeCustomizeField({
          smallCategoryCodes: smallCodes,
          smallCategoryData: smallData,
        });
        break;

      case 'mediumCategory':
        const mediumData = [...formData?.mediumCategoryData]?.filter(
          (o: any) => o?.code !== code,
        );
        const mediumCodes = [...mediumData]?.map(o => o?.code);

        onChangeCustomizeField({
          mediumCategoryCodes: mediumCodes,
          mediumCategoryData: mediumData,
        });
        break;
      case 'subCategory':
        const subData = [...formData?.subCategoryData]?.filter(
          (o: any) => o?.code !== code,
        );
        const subCodes = [...subData]?.map(o => o?.code);

        onChangeCustomizeField({
          subCategoryCodes: subCodes,
          subCategoryData: subData,
        });
        break;
      case 'supplyUnitPriceGroup':
        const supplyData = [...formData?.supplyUnitPriceGroupData]?.filter(
          (o: any) => o?.code !== code,
        );
        const supplyCodes = [...supplyData]?.map(o => o?.code);

        onChangeCustomizeField({
          supplyUnitPriceGroupIds: supplyCodes,
          supplyUnitPriceGroupData: supplyData,
        });
        break;
      case 'productType':
        const ptData = [...formData?.productTypeData]?.filter(
          (o: any) => o?.code !== code,
        );
        const productTypeCodes = [...ptData]?.map(o => o?.code);

        onChangeCustomizeField({
          productTypes: productTypeCodes,
          productTypeData: ptData,
        });
        break;
      default:
        break;
    }
  };

  /**
   * on submit common code
   *
   * @param {*} data
   */
  const onSubmitCommonCode = data => {
    let lData: any = [];
    switch (typeModalCommonCode) {
      case 'largeCategory':
        lData = [...formData?.largeCategoryData].concat(data);
        break;
      case 'mediumCategory':
        lData = [...formData?.mediumCategoryData].concat(data);
        break;
      case 'smallCategory':
        lData = [...formData?.smallCategoryData].concat(data);
        break;
      case 'subCategory':
        lData = [...formData?.subCategoryData].concat(data);
        break;
      case 'productType':
        lData = [...formData?.productTypeData].concat(data);
        break;
      case 'supplyUnitPriceGroup':
        lData = [...formData?.supplyUnitPriceGroupData].concat(data);
        break;
      default:
        break;
    }
    onChangeCommonCode(uniqBy(lData, 'code'), typeModalCommonCode);
    setShowModalCommonCode(!showModalCommonCode);
  };

  let commonCodeTitle = '';
  let commonCodeText = '';
  let commonCodeType = '';

  switch (typeModalCommonCode) {
    case 'largeCategory':
      commonCodeTitle = t('Large Category');
      commonCodeText = formData.largeCategoryName;
      commonCodeType = 'LC';
      break;
    case 'mediumCategory':
      commonCodeTitle = t('Medium Category');
      commonCodeText = formData.mediumCategoryName;
      commonCodeType = 'MC';
      break;
    case 'smallCategory':
      commonCodeTitle = t('Small Category');
      commonCodeText = formData.smallCategoryName;
      commonCodeType = 'SC';
      break;
    case 'subCategory':
      commonCodeTitle = t('Sub Category');
      commonCodeText = formData.subCategoryName;
      commonCodeType = 'UC';
      break;
    case 'productType':
      commonCodeTitle = t('Product Type');
      commonCodeText = formData.productTypeName;
      commonCodeType = 'PT';
      break;
    case 'supplyUnitPriceGroup':
      commonCodeTitle = t('Supply Unit Price Group');
      commonCodeText = formData.supplyUnitPriceGroupName;
      commonCodeType = 'SP';
      break;
    default:
      break;
  }

  /**
   * on change product group
   *
   * @param {*} data
   */
  const onChangeProductGroup = data => {
    const ids = [...data]?.map(o => o?.productGroupId);
    onChangeCustomizeField({
      productGroupIds: ids,
      productGroupName: '',
      productGroupData: data,
    });
  };

  /**
   *
   *
   * @param {*} productGroupId
   */
  const onRemoveProductGroup = productGroupId => {
    const l = [...formData?.productGroupData]?.filter(
      (o: any) => o?.productGroupId !== productGroupId,
    );
    const ids = [...l]?.map(o => o?.productGroupId);
    onChangeCustomizeField({
      productGroupIds: ids,
      productGroupName: '',
      productGroupData: l,
    });
  };

  /**
   * on submit
   *
   * @return {*}
   */
  const onSubmit = () => {
    const isValid = formRef?.current?.instance?.validate()?.isValid;
    if (!isValid) return collapseRef?.current?.onCollappse();
    const fixFormData = { ...formData };

    delete fixFormData.storeName;
    delete fixFormData.productTypeName;
    delete fixFormData.supplyUnitPriceGroupName;
    delete fixFormData.largeCategoryName;
    delete fixFormData.mediumCategoryName;
    delete fixFormData.smallCategoryName;
    delete fixFormData.subCategoryName;
    delete fixFormData.productGroupName;

    delete fixFormData.storeData;
    delete fixFormData.productTypeData;
    delete fixFormData.supplyUnitPriceGroupData;
    delete fixFormData.largeCategoryData;
    delete fixFormData.mediumCategoryData;
    delete fixFormData.smallCategoryData;
    delete fixFormData.subCategoryData;
    delete fixFormData.productGroupData;

    makeDataStores({
      ...fixFormData,
    });
  };

  /**
   * render search
   *
   * @param {*} { name }
   * @return {*}
   */
  const Search = ({ name }) => {
    return (
      <>
        <Form
          formData={formData}
          ref={formRef}
          showColonAfterLabel={false}
          items={[
            {
              label: {
                text: t('Store'),
              },
              dataField: 'storeName',
              editorType: 'dxTextBox',
              isRequired: !formData?.storeData?.length,
              editorOptions: {
                onEnterKey: () => {
                  setShowModalStore(!showModalStore);
                },
                showClearButton: true,
                buttons: [
                  {
                    name: 'store1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: formData?.storeData?.[0]?.storeNm,
                      onClick: () =>
                        onRemoveStore(formData?.storeData?.[0]?.storeNo),
                      visible: !!formData?.storeData?.[0]?.storeNo,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'store2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: formData?.storeData?.[1]?.storeNm,
                      onClick: () =>
                        onRemoveStore(formData?.storeData?.[1]?.storeNo),
                      visible: !!formData?.storeData?.[1]?.storeNo,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'storeMore',
                    location: 'before',
                    options: {
                      text: `+ ${formData?.storeData?.length - 2} ${t('more')}`,
                      visible: formData?.storeData?.length > 2,
                    },
                  },
                  {
                    name: 'storeClearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!formData?.storeData?.length,
                      onClick: () => onChangeStore([]),
                    },
                  },
                  {
                    name: 'storeSearch',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => {
                        setShowModalStore(!showModalStore);
                      },
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Product Type') },
              dataField: 'productTypeName',
              editorType: 'dxTextBox',
              editorOptions: {
                readOnly: formData?.isReadOnlyProductTp,
                onEnterKey: () => {
                  setTypeModalCommonCode('productType');
                  setShowModalCommonCode(!showModalCommonCode);
                },
                showClearButton: true,
                buttons: [
                  {
                    name: 'productType1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: formData?.productTypeData?.[0]?.name,
                      onClick: () =>
                        onRemoveCommonCode(
                          formData?.productTypeData?.[0]?.code,
                          'productType',
                        ),
                      visible: !!formData?.productTypeData?.[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'productType2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: formData?.productTypeData?.[1]?.name,
                      onClick: () =>
                        onRemoveCommonCode(
                          formData?.productTypeData?.[1]?.code,
                          'productType',
                        ),
                      visible: !!formData?.productTypeData?.[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'productTypeMore',
                    location: 'before',
                    options: {
                      text: `+ ${formData?.productTypeData?.length - 2} ${t(
                        'more',
                      )}`,
                      visible: formData?.productTypeData?.length > 2,
                    },
                  },
                  {
                    name: 'productTypeClearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!formData?.productTypeData?.length,
                      onClick: () => onChangeCommonCode([], 'productType'),
                    },
                  },
                  {
                    name: 'productTypeSearch',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => {
                        setTypeModalCommonCode('productType');
                        setShowModalCommonCode(!showModalCommonCode);
                      },
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Supply Unit Price Group') },
              dataField: 'supplyUnitPriceGroupName',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => {
                  setTypeModalCommonCode('supplyUnitPriceGroup');
                  setShowModalCommonCode(!showModalCommonCode);
                },
                showClearButton: true,
                buttons: [
                  {
                    name: 'supplyUnitPriceGroup1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: formData?.supplyUnitPriceGroupData?.[0]?.name,
                      onClick: () =>
                        onRemoveCommonCode(
                          formData?.supplyUnitPriceGroupData?.[0]?.code,
                          'supplyUnitPriceGroup',
                        ),
                      visible: !!formData?.supplyUnitPriceGroupData?.[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'supplyUnitPriceGroup2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: formData?.supplyUnitPriceGroupData?.[1]?.name,
                      onClick: () =>
                        onRemoveCommonCode(
                          formData?.supplyUnitPriceGroupData?.[1]?.code,
                          'supplyUnitPriceGroup',
                        ),
                      visible: !!formData?.supplyUnitPriceGroupData?.[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'supplyUnitPriceGroupMore',
                    location: 'before',
                    options: {
                      text: `+ ${
                        formData?.supplyUnitPriceGroupData?.length - 2
                      } ${t('more')}`,
                      visible: formData?.supplyUnitPriceGroupData?.length > 2,
                    },
                  },
                  {
                    name: 'supplyUnitPriceGroupClearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!formData?.supplyUnitPriceGroupData?.length,
                      onClick: () =>
                        onChangeCommonCode([], 'supplyUnitPriceGroup'),
                    },
                  },
                  {
                    name: 'supplyUnitPriceGroupSearch',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => {
                        setTypeModalCommonCode('supplyUnitPriceGroup');
                        setShowModalCommonCode(!showModalCommonCode);
                      },
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Product') },
              dataField: 'product',
              editorType: 'dxTextBox',
            },
          ]}
          labelLocation="top"
          colCount={2}
        ></Form>
      </>
    );
  };
  /**
   * render advanced search
   *
   * @param {*} { name }
   * @return {*}
   */
  const AdvancedSearch = ({ name }) => {
    return (
      <>
        <Form
          formData={formData}
          showColonAfterLabel={false}
          items={[
            {
              label: { text: t('Large Category') },
              dataField: 'largeCategoryName',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => {
                  setTypeModalCommonCode('largeCategory');
                  setShowModalCommonCode(!showModalCommonCode);
                },
                showClearButton: true,
                buttons: [
                  {
                    name: 'largeCategory1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: formData?.largeCategoryData?.[0]?.name,
                      onClick: () =>
                        onRemoveCommonCode(
                          formData?.largeCategoryData?.[0]?.code,
                          'largeCategory',
                        ),
                      visible: !!formData?.largeCategoryData?.[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'largeCategory2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: formData?.largeCategoryData?.[1]?.name,
                      onClick: () =>
                        onRemoveCommonCode(
                          formData?.largeCategoryData?.[1]?.code,
                          'largeCategory',
                        ),
                      visible: !!formData?.largeCategoryData?.[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'largeCategoryMore',
                    location: 'before',
                    options: {
                      text: `+ ${formData?.largeCategoryData?.length - 2} ${t(
                        'more',
                      )}`,
                      visible: formData?.largeCategoryData?.length > 2,
                    },
                  },
                  {
                    name: 'largeCategoryClearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!formData?.largeCategoryData?.length,
                      onClick: () => onChangeCommonCode([], 'largeCategory'),
                    },
                  },
                  {
                    name: 'largeCategorySearch',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => {
                        setTypeModalCommonCode('largeCategory');
                        setShowModalCommonCode(!showModalCommonCode);
                      },
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Medium Category') },
              dataField: 'mediumCategoryName',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => {
                  setTypeModalCommonCode('mediumCategory');
                  setShowModalCommonCode(!showModalCommonCode);
                },
                showClearButton: true,
                buttons: [
                  {
                    name: 'mediumCategory1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: formData?.mediumCategoryData?.[0]?.name,
                      onClick: () =>
                        onRemoveCommonCode(
                          formData?.mediumCategoryData?.[0]?.code,
                          'mediumCategory',
                        ),
                      visible: !!formData?.mediumCategoryData?.[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'mediumCategory2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: formData?.mediumCategoryData?.[1]?.name,
                      onClick: () =>
                        onRemoveCommonCode(
                          formData?.mediumCategoryData?.[1]?.code,
                          'mediumCategory',
                        ),
                      visible: !!formData?.mediumCategoryData?.[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'mediumCategoryMore',
                    location: 'before',
                    options: {
                      text: `+ ${formData?.mediumCategoryData?.length - 2} ${t(
                        'more',
                      )}`,
                      visible: formData?.mediumCategoryData?.length > 2,
                    },
                  },
                  {
                    name: 'mediumCategoryClearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!formData?.mediumCategoryData?.length,
                      onClick: () => onChangeCommonCode([], 'mediumCategory'),
                    },
                  },
                  {
                    name: 'mediumCategorySearch',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => {
                        setTypeModalCommonCode('mediumCategory');
                        setShowModalCommonCode(!showModalCommonCode);
                      },
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Small Category') },
              dataField: 'smallCategoryName',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => {
                  setTypeModalCommonCode('smallCategory');
                  setShowModalCommonCode(!showModalCommonCode);
                },
                showClearButton: true,
                buttons: [
                  {
                    name: 'smallCategory1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: formData?.smallCategoryData?.[0]?.name,
                      onClick: () =>
                        onRemoveCommonCode(
                          formData?.smallCategoryData?.[0]?.code,
                          'smallCategory',
                        ),
                      visible: !!formData?.smallCategoryData?.[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'smallCategory2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: formData?.smallCategoryData?.[1]?.name,
                      onClick: () =>
                        onRemoveCommonCode(
                          formData?.smallCategoryData?.[1]?.code,
                          'smallCategory',
                        ),
                      visible: !!formData?.smallCategoryData?.[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'smallCategoryMore',
                    location: 'before',
                    options: {
                      text: `+ ${formData?.smallCategoryData?.length - 2} ${t(
                        'more',
                      )}`,
                      visible: formData?.smallCategoryData?.length > 2,
                    },
                  },
                  {
                    name: 'smallCategoryClearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!formData?.smallCategoryData?.length,
                      onClick: () => onChangeCommonCode([], 'smallCategory'),
                    },
                  },
                  {
                    name: 'smallCategorySearch',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => {
                        setTypeModalCommonCode('smallCategory');
                        setShowModalCommonCode(!showModalCommonCode);
                      },
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Sub Category') },
              dataField: 'subCategoryName',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () => {
                  setTypeModalCommonCode('subCategory');
                  setShowModalCommonCode(!showModalCommonCode);
                },
                showClearButton: true,
                buttons: [
                  {
                    name: 'subCategory1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: formData?.subCategoryData?.[0]?.name,
                      onClick: () =>
                        onRemoveCommonCode(
                          formData?.subCategoryData?.[0]?.code,
                          'subCategory',
                        ),
                      visible: !!formData?.subCategoryData?.[0]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'subCategory2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: formData?.subCategoryData?.[1]?.name,
                      onClick: () =>
                        onRemoveCommonCode(
                          formData?.subCategoryData?.[1]?.code,
                          'subCategory',
                        ),
                      visible: !!formData?.subCategoryData?.[1]?.code,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'subCategoryMore',
                    location: 'before',
                    options: {
                      text: `+ ${formData?.subCategoryData?.length - 2} ${t(
                        'more',
                      )}`,
                      visible: formData?.subCategoryData?.length > 2,
                    },
                  },
                  {
                    name: 'subCategoryClearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!formData?.subCategoryData?.length,
                      onClick: () => onChangeCommonCode([], 'subCategory'),
                    },
                  },
                  {
                    name: 'subCategorySearch',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () => {
                        setTypeModalCommonCode('subCategory');
                        setShowModalCommonCode(!showModalCommonCode);
                      },
                    },
                  },
                ],
              },
            },
            {
              label: { text: t('Product Group') },
              dataField: 'productGroupName',
              editorType: 'dxTextBox',
              editorOptions: {
                onEnterKey: () =>
                  setShowModalProductGroup(!showModalProductGroup),
                showClearButton: true,
                buttons: [
                  {
                    name: 'productGroup1',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: formData?.productGroupData?.[0]?.productGroupNm,
                      onClick: () =>
                        onRemoveProductGroup(
                          formData?.productGroupData?.[0]?.productGroupId,
                        ),
                      visible:
                        !!formData?.productGroupData?.[0]?.productGroupId,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'productGroup2',
                    location: 'before',
                    options: {
                      icon: 'close',
                      text: formData?.productGroupData?.[1]?.productGroupNm,
                      onClick: () =>
                        onRemoveProductGroup(
                          formData?.productGroupData?.[1]?.productGroupId,
                        ),
                      visible:
                        !!formData?.productGroupData?.[1]?.productGroupId,
                      rtlEnabled: true,
                    },
                  },
                  {
                    name: 'productGroupMore',
                    location: 'before',
                    options: {
                      text: `+ ${formData?.productGroupData?.length - 2} ${t(
                        'more',
                      )}`,
                      visible: formData?.productGroupData?.length > 2,
                    },
                  },
                  {
                    name: 'productGroupClearAll',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'close',
                      visible: !!formData?.productGroupData?.length,
                      onClick: () => onChangeProductGroup([]),
                    },
                  },
                  {
                    name: 'productGroupSearch',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: 'search',
                      onClick: () =>
                        setShowModalProductGroup(!showModalProductGroup),
                    },
                  },
                ],
              },
            },
          ]}
          labelLocation="top"
          colCount={3}
        ></Form>
      </>
    );
  };
  /**
   * fetch data
   */
  useEffect(() => {
    if (!params?.productTypeData?.length) return;
    setFormData(preState => ({
      ...preState,
      productTypeData: params?.productTypeData,
      productTypes: params?.productTypes,
      isReadOnlyProductTp: params.isReadOnlyProductTp,
    }));
  }, [params?.productTypeData]);

  return (
    <div>
      <Collapse onSubmit={onSubmit} ref={collapseRef}>
        <Search name={t('Search')} />
        <AdvancedSearch name={t('Advanced Search')} />
      </Collapse>
      {showModalStore && (
        <PopupSelectStore
          visible={showModalStore}
          text={formData.storeName}
          onHiding={() => setShowModalStore(!showModalStore)}
          onSubmit={(data: any) => {
            const storeData = [...formData?.storeData].concat(data);
            onChangeStore(uniqBy(storeData, 'storeNo'));
            setShowModalStore(!showModalStore);
          }}
          mode="multiple"
        />
      )}
      {showModalCommonCode && (
        <PopupSelectCommonCode
          visible={showModalCommonCode}
          text={commonCodeText}
          codeType={commonCodeType}
          mode="multiple"
          onHiding={() => setShowModalCommonCode(!showModalCommonCode)}
          onSubmit={data => onSubmitCommonCode(data)}
        />
      )}
      {showModalProductGroup && (
        <PopupSelectProductGroup
          visible={showModalProductGroup}
          text={formData?.productGroupName}
          onHiding={() => {
            setShowModalProductGroup(!showModalProductGroup);
          }}
          mode="multiple"
          onSubmit={data => {
            const l = [...formData?.productGroupData].concat(data);
            onChangeProductGroup(uniqBy(l, 'productGroupId'));
            setShowModalProductGroup(!showModalProductGroup);
          }}
        />
      )}
    </div>
  );
};
export default FormSearch;
